var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOlympicWeights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 19V50.6667M38 19V50.6667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 19V50.6667M38 19V50.6667",
    stroke: "url(#paint0_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.833 25.3333V34.8333M129.833 34.8333V44.3332M129.833 34.8333H139.333M22.1665 25.3333V34.8333M22.1665 34.8333V44.3332M22.1665 34.8333H12.6665",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.833 25.3333V34.8333M129.833 34.8333V44.3332M129.833 34.8333H139.333M22.1665 25.3333V34.8333M22.1665 34.8333V44.3332M22.1665 34.8333H12.6665",
    stroke: "url(#paint1_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114 34.8333H38",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 34.8333H38",
    stroke: "url(#paint2_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0845 120.333H105.915C113.753 120.333 117.671 120.333 119.292 118.417C122.97 114.068 115.924 108.32 113.353 105.422C110.456 102.158 108.337 101.333 104.056 101.333H47.944C43.6623 101.333 41.5435 102.158 38.6467 105.422C36.0756 108.32 29.0302 114.068 32.7079 118.417C34.3281 120.333 38.2469 120.333 46.0845 120.333Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0845 120.333H105.915C113.753 120.333 117.671 120.333 119.292 118.417C122.97 114.068 115.924 108.32 113.353 105.422C110.456 102.158 108.337 101.333 104.056 101.333H47.944C43.6623 101.333 41.5435 102.158 38.6467 105.422C36.0756 108.32 29.0302 114.068 32.7079 118.417C34.3281 120.333 38.2469 120.333 46.0845 120.333Z",
    stroke: "url(#paint3_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50.6667V101.333M95 50.6667V101.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50.6667V101.333M95 50.6667V101.333",
    stroke: "url(#paint4_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 120.333V133M50.6665 120.333V133",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 120.333V133M50.6665 120.333V133",
    stroke: "url(#paint5_linear_16725_939)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_939",
    x1: 38,
    y1: 19,
    x2: 104.552,
    y2: 64.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_939",
    x1: 12.6665,
    y1: 25.3333,
    x2: 48.008,
    y2: 92.4338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_939",
    x1: 38,
    y1: 34.8333,
    x2: 38.208,
    y2: 39.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_939",
    x1: 31.6665,
    y1: 101.333,
    x2: 72.8465,
    y2: 156.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_939",
    x1: 57,
    y1: 50.6667,
    x2: 103.692,
    y2: 60.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16725_939",
    x1: 50.6665,
    y1: 120.333,
    x2: 78.9972,
    y2: 152.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicWeights);
export default __webpack_public_path__ + "static/media/Olympic-weights.92c62b63d82fd7042f639cea9ab77e5e.svg";
export { ForwardRef as ReactComponent };